import { gql } from '@apollo/client';

const GET_COMBO_DETALLE_OBITO = gql`
    query comboDetalleObito {
        detalleObitos {
            idDetalleObito
            descripcion
        }
    }
`;

export default GET_COMBO_DETALLE_OBITO;

const adaptDetalleObito = (detalleObito) => {
    return {
        id: detalleObito?.idDetalleObito,
        displayName: detalleObito?.descripcion
    };
}

export const adaptComboDetalleObitoArray = (comboDetalleObito) => {
    return structuredClone(comboDetalleObito)?.map((detalleObito) => adaptDetalleObito(detalleObito));
}

